export const logApiResponse = (
  endpoint: string,
  request: any,
  response: any,
  transformedData?: any
) => {
  if (process.env.NODE_ENV === 'development') {
    console.group(`🔍 API Debug: ${endpoint}`);
    console.log('📤 Request:', request);
    console.log('📥 Response:', response);
    if (transformedData) {
      console.log('🔄 Transformed:', transformedData);
    }
    console.groupEnd();
  }
};

export const validateApiResponse = (
  response: any,
  expectedFields: string[],
  context: string = 'API Response'
): { isValid: boolean; missingFields: string[] } => {
  if (!response) {
    console.warn(`⚠️ ${context}: Response is null or undefined`);
    return { isValid: false, missingFields: expectedFields };
  }

  const missingFields: string[] = [];
  
  expectedFields.forEach(field => {
    const fieldPath = field.split('.');
    let current = response;
    
    for (const key of fieldPath) {
      if (current && typeof current === 'object' && key in current) {
        current = current[key];
      } else {
        missingFields.push(field);
        break;
      }
    }
  });

  if (missingFields.length > 0) {
    console.warn(`⚠️ ${context}: Missing fields:`, missingFields);
  }

  return {
    isValid: missingFields.length === 0,
    missingFields
  };
};

export const logBulkSearchResults = (
  barcodes: string[],
  results: any[],
  processingTime?: number
) => {
  if (process.env.NODE_ENV === 'development') {
    console.group(`📊 Bulk Search Results (${barcodes.length} barcodes)`);
    console.log('🎯 Success Rate:', `${results.filter(r => r.found).length}/${results.length}`);
    
    if (processingTime) {
      console.log('⚡ Processing Time:', `${processingTime}ms`);
      console.log('📈 Avg per barcode:', `${(processingTime / barcodes.length).toFixed(2)}ms`);
    }
    
    const failed = results.filter(r => !r.found);
    if (failed.length > 0) {
      console.log('❌ Failed barcodes:', failed.map(r => r.barcode));
    }
    
    console.groupEnd();
  }
};

export const validateBulkSearchResponse = (response: any): boolean => {
  const validation = validateApiResponse(response, [
    'success',
    'data',
    'data.results'
  ], 'Bulk Search Response');

  if (!validation.isValid) {
    return false;
  }

  // Validate each result item
  if (Array.isArray(response.data.results)) {
    const invalidItems = response.data.results.filter((item: any) => {
      return !item.barcode || (item.result && !item.result.type);
    });

    if (invalidItems.length > 0) {
      console.warn('⚠️ Invalid result items found:', invalidItems);
      return false;
    }
  }

  return true;
};